<section class="diagnosis-section">
  @if (diagnoses.length > 0 && !isLoading) {
    <div class="table-container">
      <table mat-table [dataSource]="diagnoses" class="diagnosis-table">
        <!-- Code Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>Codice</th>
          <td mat-cell *matCellDef="let diagnosis">{{ diagnosis.code }}</td>
        </ng-container>
        <!-- Description Column -->
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef>Descrizione</th>
          <td mat-cell *matCellDef="let diagnosis">
            {{ diagnosis.description }}
          </td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Data</th>
          <td mat-cell *matCellDef="let diagnosis">{{ diagnosis.date }}</td>
        </ng-container>
        <!-- Notes Column -->
        <ng-container matColumnDef="notes">
          <th mat-header-cell *matHeaderCellDef>Note</th>
          <td mat-cell *matCellDef="let diagnosis">{{ diagnosis.notes }}</td>
        </ng-container>
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let diagnosis">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              class="action-button"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                (click)="handleMenuAction('edit', diagnosis)"
              >
                <mat-icon>edit</mat-icon>
                <span>Modifica</span>
              </button>
              <button
                mat-menu-item
                (click)="handleMenuAction('delete', diagnosis)"
              >
                <mat-icon>delete</mat-icon>
                <span>Elimina</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  }
  @if (isLoading) {
    <div class="loading-container">
      <app-loader [size]="'big'"></app-loader>
    </div>
  }
  @if (diagnoses.length === 0 && !isLoading) {
    <div class="no-diagnoses">
      <img
        src="assets/imgs/undraw/undraw_waiting_for_you.svg"
        alt="Nessuna Diagnosi"
      />
      <span>Nessuna diagnosi disponibile</span>
    </div>
  }
</section>

<!-- modify diagnosis panel -->
@if (showModifyPanel) {
  <app-panel-with-input-boxes
    [title]="'Modifica Diagnosi'"
    [inputBoxes]="inputBoxesForModifyDiagnosis"
    (cancel)="toggleModifyPanel()"
    (confirm)="confirmModifyDiagnosis($event)"
  ></app-panel-with-input-boxes>
}

<!-- add diagnosis panel -->
@if (showNewDiagnosisPanel) {
  <app-panel-with-input-boxes
    [title]="'Nuova Diagnosi'"
    [inputBoxes]="inputBoxesForNewDiagnosis"
    (cancel)="toggleNewDiagnosisPanel()"
    (confirm)="confirmNewDiagnosis($event)"
  ></app-panel-with-input-boxes>
}
